import React from 'react';
import Box from 'src/components/PulseUI/Box/Box';

const CardHeaderContainer = ({ children }: { children: React.ReactNode }) => {
  return <Box className="flex flex-col gap-2">{children}</Box>;
};

export default CardHeaderContainer;
